import React from "react";
import "../styles/Tracks.css";

const Tracks = () => {
  const tracks = [
    {
      id: 1,
      title: "Cyber Physical Systems, Hardware & Network Innovations",
      description:
        "This track examines the integration of computation, networking, and physical processes. It highlights the role of computing in solving real-world problems through robotics, IoT, smart infrastructure, and collaborations with other engineering and scientific disciplines.",
      topics: [
        "Robotics: Perception, Planning, Control, and Human-Robot Interaction",
        "Real-Time and Embedded Systems Engineering",
        "Internet of Things (IoT) System Integration and Sensor Networks",
        "Smart Cities, Autonomous Vehicles, and Intelligent Transportation Systems",
        "Computational Biology, Bioinformatics, and Digital Health Systems",
        "Scientific Computing and High-Performance Computing (HPC) Applications",
      ],
    },
    {
      id: 2,
      title: "Intelligent Systems and Business Applications",
      description:
        "This track moves beyond ML theory to focus on the engineering of robust, scalable, and responsible intelligent systems. It covers the full pipeline from model design and training to deployment, maintenance, and ethical governance.",
      topics: [
        "MLOps (CI/CD, Orchestration, and Scalable Deployment of ML Models)",
        "Agentic AI and EAI, AR/VR, Digital Twins",
        "Engineering for Large Language Models and Foundational Models",
        "Efficient AI (Model Compression, Quantization, and Hardware-Aware Training)",
        "Data Engineering and Governance for AI (Pipelines, Versioning, Quality)",
        "Reinforcement Learning Systems and Real-World Applications",
        "Responsible AI Engineering (Bias Mitigation, Explainability, and Auditability)",
      ],
    },
    {
      id: 3,
      title: "Mathematical Computing, Algorithmic Design and Quantum Computing",
      description:
        "Delving into the mathematical core of computing, this track covers advances in the design, analysis, and limits of algorithms and computational models. It connects theoretical insights to practical, scalable solutions for complex problems.",
      topics: [
        "Design and Analysis of Algorithms (Approximation, Randomized, Online)",
        "Computational Complexity Theory and Quantum Algorithms",
        "Theoretical Foundations of Computing",
        "Formal Methods, Program Verification, and Logic",
        "Algorithmic Game Theory and Fairness in Computational Systems",
        "Quantum Technology and its application in solving real world problems",
      ],
    },
    {
      id: 4,
      title: "Security and Cryptography including Blockchain Technology",
      description:
        "This track covers the fundamental and applied research securing our digital world, from cryptographic theory to deployed systems. It explores how to protect data, communications, and infrastructure, and how blockchain technology enables new paradigms of decentralized trust and transaction.",
      topics: [
        "Foundational Cryptography: Post-quantum algorithms, advanced encryption, and privacy protocols",
        "System & Network Security: Threat defence, hardware security, and formal verification",
        "Blockchain & DLTs: Scalability solutions, consensus mechanisms, smart contract security, and interoperability",
        "Privacy & Trust: Decentralized identity, privacy-preserving tech, and policy impacts",
      ],
    },

    {
      id: 5,
      title: "Sustainable Development goals including Earth Exploration",
      description:
        "This track explores the critical role of computational science and engineering in achieving the Sustainable Development Goals (SDGs) related to responsible consumption, climate action, and life on land. It focuses on technologies for the sustainable exploration, extraction, and management of Earth's resources—including minerals, metals, and traditional resources like coal—balancing environmental stewardship, social equity, and economic viability.",
      topics: [
        "Geo-informatics & Remote Sensing",
        "AI/ML for Resource Management (Predictive modelling for resource discovery, optimizing extraction processes for efficiency, and reducing ecological footprint)",
        "Automation & Robotics (Deploying autonomous systems for safer, more precise mining and exploration in hazardous environments)",
        "Circular Economy & Critical Minerals (Data-driven systems for recycling, tracking material flows, and securing supply chains for the energy transition)",
      ],
    },
  ];

  const [expandedTrack, setExpandedTrack] = React.useState(null);
  const sortedTracks = [...tracks].sort((a, b) =>
    a.title.localeCompare(b.title),
  );
  const toggleTrack = (trackId) => {
    setExpandedTrack(expandedTrack === trackId ? null : trackId);
  };

  return (
    <section id="tracks" className="tracks">
      <div className="container">
        <h2 className="section-title">Conference Tracks</h2>
        <p className="section-subtitle">
          Five Multidisciplinary Tracks Fostering Innovation and Collaboration
        </p>

        <div className="tracks-container">
          {sortedTracks.map((track) => (
            <div
              key={track.id}
              className={`track-card ${expandedTrack === track.id ? "expanded" : ""}`}
            >
              <div
                className="track-header"
                onClick={() => toggleTrack(track.id)}
              >
                <h3 className="track-number">Track {track.id}</h3>
                <h4 className="track-title">{track.title}</h4>
                <button className="expand-btn">
                  {expandedTrack === track.id ? "−" : "+"}
                </button>
              </div>

              {expandedTrack === track.id && (
                <div className="track-content">
                  <p className="track-description">{track.description}</p>
                  <h5 className="topics-title">Key Topics:</h5>
                  <ul className="topics-list">
                    {track.topics.map((topic, index) => (
                      <li key={index}>{topic}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tracks;
